/** Internal staff (admin) accounts must use this email domain. */
export const STAFF_EMAIL_DOMAIN = 'hamssah.com';

export function normalizeStaffEmail(email: string): string {
  return email.trim().toLowerCase();
}

export function isStaffEmailDomain(
  email: string,
  domain: string = STAFF_EMAIL_DOMAIN,
): boolean {
  const normalized = normalizeStaffEmail(email);
  const at = normalized.lastIndexOf('@');
  if (at < 0) return false;
  return normalized.slice(at + 1) === domain.trim().toLowerCase();
}

/** French validation message for admin/staff flows; `null` when allowed. */
export const STAFF_EMAIL_DOMAIN_REJECTED_MESSAGE =
  'Cette adresse e-mail n’est pas autorisée.';

export function getStaffEmailDomainValidationError(
  email: string,
  domain: string = STAFF_EMAIL_DOMAIN,
): string | null {
  if (isStaffEmailDomain(email, domain)) return null;
  return STAFF_EMAIL_DOMAIN_REJECTED_MESSAGE;
}
